import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/avatar_sel.png'


const _withScopeId = n => (_pushScopeId("data-v-eddd8c5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "conterbox" }
const _hoisted_3 = { class: "itembox" }
const _hoisted_4 = { class: "rightbox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ID", -1 /* HOISTED */))
const _hoisted_6 = { class: "rightbox" }
const _hoisted_7 = { class: "conterbox" }
const _hoisted_8 = { class: "rightbox" }
const _hoisted_9 = { class: "overlayBox" }
const _hoisted_10 = { class: "avatarBox" }
const _hoisted_11 = { class: "topNav" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = {
  key: 0,
  class: "imgList"
}
const _hoisted_14 = { class: "morenavatarbox" }
const _hoisted_15 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "avatarsel"
}
const _hoisted_16 = { class: "opuits" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.grzl'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('me.avatar')), 1 /* TEXT */),
        _createElementVNode("div", {
          class: "rightbox",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.nameimg()))
        }, [
          _createVNode(_component_van_image, {
            round: "",
            width: "35",
            height: "35",
            src: $setup.user.avatar
          }, null, 8 /* PROPS */, ["src"]),
          _createVNode(_component_van_icon, {
            class: "icon",
            name: "arrow",
            color: "#898989",
            size: "10"
          })
        ])
      ]),
      _createVNode(_component_van_divider, { style: {"margin-left":"10px","margin-right":"10px"} }),
      _createElementVNode("div", {
        class: "itembox",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push('/selfinfo')))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('me.username')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString($setup.user.nickName), 1 /* TEXT */),
          _createVNode(_component_van_icon, {
            class: "icon",
            name: "arrow",
            color: "#898989",
            size: "10"
          })
        ])
      ]),
      _createVNode(_component_van_divider, { style: {"margin-left":"10px","margin-right":"10px"} }),
      _createElementVNode("div", {
        class: "itembox",
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.router.push(`/lookid?id=${$setup.user.fid }`)))
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", null, _toDisplayString($setup.user.fid), 1 /* TEXT */),
          _createVNode(_component_van_icon, {
            class: "icon",
            name: "arrow",
            color: "#898989",
            size: "10"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "itembox",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.router.push('/sign')))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('me.gxqm')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString($setup.user.sign == "" ? $setup.t('me.nosetting') : $setup.user.sign), 1 /* TEXT */),
          _createVNode(_component_van_icon, {
            class: "icon",
            name: "arrow",
            color: "#898989",
            size: "10"
          })
        ])
      ])
    ]),
    _createVNode(_component_van_overlay, {
      show: $setup.downloadshow,
      "z-index": "99"
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" <div class=\"flexcenter\" style=\"min-height: 100vh\" @click.stop>\r\n        <div class=\"dolne\">\r\n          <div class=\"dolne-box\">\r\n            <img class=\"dolne-bg\" :src=\"showDialogBg\" alt=\"\" />\r\n            <img class=\"dolne-jiantou\" @click=\"open()\" :src=\"jiantou\" alt=\"\" />\r\n          </div>\r\n          <img class=\"dolne-on\" @click=\"downloadshow = false\" :src=\"ICON_CLOSE\" alt=\"\" />\r\n        </div>\r\n      </div> "),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('me.xtavatar')), 1 /* TEXT */),
              _createElementVNode("div", {
                class: "ok",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ( $setup.morlAvatar()))
              }, _toDisplayString(_ctx.$t('im.wanc')), 1 /* TEXT */)
            ]),
            ($setup.avatar.length>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.avatar, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_van_image, {
                        width: "55",
                        onClick: ($event: any) => ($setup.checkUrl(item,index)),
                        fit: "cover",
                        position: "contain",
                        height: "55",
                        round: "",
                        src: item.url
                      }, null, 8 /* PROPS */, ["onClick", "src"]),
                      (item.check)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_van_uploader, {
              "before-read": $setup.beforeRead,
              "max-size": 1000 * 1024,
              onOversize: $setup.onOversize,
              "after-read": $setup.afterRead,
              multiple: "",
              "max-count": 1
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('me.xc')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _createElementVNode("div", {
            class: "cancel",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.downloadshow = false))
          }, _toDisplayString(_ctx.$t('tips.cancel')), 1 /* TEXT */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ]))
}